<template>
  <div class="section upcoming_ws_wrapper">
    <div class="container">
      <h3 class="upcoming_title">Recently added</h3>
<!--      <a href class="view_all_workshop">view all</a>-->
      <div class="upcoming_workshop">
        <div class="upcoming_workshop_item" v-for="w in workshops" :key="w.id">
          <img
            class="img-fluid"
            :src="'https://backend.upskill.com.bd' + w.image"
            alt
          />
          <p class="upcoming_desc">{{ w.name }}</p>
          <a class="upcoming_action hover" @click="GotoWS(w.id)">
            View workshop
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7.433"
              height="13"
              viewBox="0 0 7.433 13"
            >
              <path
                id="Icon_ionic-ios-arrow-forward"
                data-name="Icon ionic-ios-arrow-forward"
                d="M16.439,12.694,11.519,7.778a.925.925,0,0,1,0-1.312.937.937,0,0,1,1.316,0l5.574,5.57a.927.927,0,0,1,.027,1.281l-5.6,5.608a.929.929,0,1,1-1.316-1.312Z"
                transform="translate(-11.246 -6.196)"
                fill="#0062ff"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "@/modules/tab";

export default {
  data() {
    return {
      workshops: []
    };
  },
  created() {
    this.$upskill.workshops().then(res => {
      this.workshops = res.data.data;
      this.workshops = this.workshops.slice(0,5)
    });
  },
  mounted() {
    new Tab();
  }
};
</script>
<style scoped>


</style>